export default "__VITE_ASSET__280acd19__"